// API Configuration
// Centralized configuration for API endpoints
// Change the API_BASE_URL here to update it across the entire application

// You can use environment variables for different environments
// For React apps, environment variables must start with REACT_APP_
const API_BASE_URL = "https://apisolution.edidact.ch/api";

// Base URL without /api suffix for storage and other endpoints
const BASE_URL = "https://apisolution.edidact.ch";

// Storage URL for file uploads and static assets
const STORAGE_BASE_URL = "https://apisolution.edidact.ch/storage";

// Runtime player base URL used to launch exercises (Play/Test/Preview/Open)
const RUNTIME_BASE_URL = "https://runtime.edidact.ch";

// Study plan (structure)
const STUDY_PLAN_API = "https://api.edidact.ch/api/getStudyPlanSolution";

// Maps an internal Solution exercise `type` to the public runtime
// `template_type` folder served by the runtime player. Mirrors the mapping
// used by the backend when publishing exercise metadata to the Laravel
// catalogue (see ExerciseController::mapTypeToTemplate).
const EXERCISE_TYPE_TO_TEMPLATE = {
  dropbox: "dropbox",
  dropbox_langue: "dropbox_langue",
  click: "click",
  click_3_choix: "click3choix",
  click_4_choix: "click4choix",
  click_phrase: "click2choixphrase",
  click_3_phrase: "click3choixphrase",
  click_4_phrase: "click4choixphrase",
  drag_and_drop_phrase: "draganddropphrase",
  drag_and_drop_paragraphe: "draganddropparag",
  clavier_maths: "clavier_maths",
  clavier_langue: "clavier_langue",
  clavier2inputs: "clavier2inputs",
  quizz: "quiz",
};

/**
 * Resolve the runtime `template_type` for a given Solution exercise `type`.
 * Falls back to the raw type when no explicit mapping exists.
 */
const getTemplateType = (type) => {
  if (!type) return type;
  return EXERCISE_TYPE_TO_TEMPLATE[type] || type;
};

/**
 * Centralized builder for runtime exercise launch URLs, used by every
 * launch action (Play/Test/Preview/Open) so the URL shape stays consistent:
 * https://runtime.edidact.ch/types/{template_type}/index.html?_id={id}&Token=...&v=...
 *
 * `token` is optional so drafts/tests can still be launched without a
 * verified token being available yet.
 */
const buildRuntimeExerciseUrl = ({ type, exerciseId, token, version }) => {
  const templateType = getTemplateType(type);
  const params = new URLSearchParams();
  params.set("_id", exerciseId);
  if (token) {
    params.set("Token", token);
  }
  params.set("v", version ?? Date.now());
  return `${RUNTIME_BASE_URL}/types/${templateType}/index.html?${params.toString()}`;
};

export {
  API_BASE_URL,
  BASE_URL,
  STORAGE_BASE_URL,
  RUNTIME_BASE_URL,
  EXERCISE_TYPE_TO_TEMPLATE,
  STUDY_PLAN_API,
  getTemplateType,
  buildRuntimeExerciseUrl,
};
